<template>
  <div id="app">
    <action-dispatcher action="getConfig">
      <component :is="template">
        <router-view v-if="hasPermission" :key="$route.fullPath" />
        <div v-else>Sem permissão</div>
      </component>
      <snow-toast v-if="!isLogged" />
    </action-dispatcher>
  </div>
</template>

<script>
import { getToken } from "./setup/api";

export default {
  computed: {
    template() {
      return this.$route.meta.template;
    },
    isLogged() {
      return this.$store.state.user.logged;
    },
    showRouterView() {
      return !this.$route.meta.protected || this.isLogged;
    },
    hasPermission() {
      if (!this.$route.meta.permissions) return true;
      return this.$route.meta.permissions.reduce(
        (result, perm) => result && this.$permissions.hasPermission(perm),
        true
      );
    }
  },
  beforeMount() {
    if (!getToken() && this.$route.meta.protected) {
      this.$router.replace({ name: "login" });
    } else if (getToken()) {
      this.$store
        .dispatch("postLogin")
        .then(user => {
          // if (
          //   !user.answered_survey &&
          //   document.location.pathname != "/pesquisa"
          // )
          //   this.$router.replace({ name: "survey" });
          // else if (
          //   user.answered_survey &&
          //   document.location.pathname == "/pesquisa"
          // )
          // this.$router.replace({ name: "home" });
        })
        .catch(() => {
          this.$router.replace({
            name: "login",
            query: { path: this.$route.fullPath }
          });
        });
      if (["/login", "/register"].includes(document.location.pathname)) {
        this.$router.replace({ name: "home" });
      }
    }
  },
  watch: {
    $route: function() {
      if (!this.isLogged && this.$route.meta.protected) {
        this.$router.replace({
          name: "login",
          query: { path: this.$route.fullPath }
        });
      }
      window.scrollTo(0, 0);
    }
  }
};
</script>
